import { Component, OnInit } from '@angular/core';
import { BroadcastService } from '../core/services/broadcast.service';
import { Router } from '@angular/router';
import { AuthManagerService } from '../api/auth/auth-manager.service';
import { LoginGuardService } from '../core/login-guard.service';

// noinspection JSIgnoredPromiseFromCall
@Component({
    selector: 'myapp-start',
    templateUrl: './start.component.html',
    styleUrls: ['./start.component.less']
})
export class StartComponent implements OnInit
{
    constructor(private authManager: AuthManagerService,
                private broadcastService: BroadcastService,
                private router: Router)
    {
    }

    ngOnInit()
    {
        this.tryAutoSignIn();
    }

    private tryAutoSignIn()
    {
        const authenticatedUser = this.authManager.authenticatedUser;

        if (!authenticatedUser || !authenticatedUser.isLoggedIn())
        {
            this.router.navigate(['/account/sign-in']);
            return;
        }

        const path = LoginGuardService.firstAvailableComponent(authenticatedUser!);
        this.router.navigate([ '/section/' + path ]);
    }
}
